@if (jsBridge == undefined) {
<div>
    Loading ....
</div>
} @else if (!this.jsBridgeService.isVersionSupported()) {
    <div class="notSupported">Version {{this.jsBridgeService.version()}} not suppported! <a href="/">Home</a></div>
    @if (this.electronAPI.isSercom()) {
        <legacy-info></legacy-info>
    }
} @else {
<div class="konfig-container" [ngClass]="{ 'custom-styles': true }">
    <app-bar class="bar"><ng-content select="[app-bar-menu]"></ng-content></app-bar>
    <as-split unit="pixel" [direction]="'horizontal'">
        <as-split-area size="375" *ngIf="this.kopConfigService.isDetail()">
            <module-bar />
        </as-split-area>
        <as-split-area size="*">
            <app-afdeling-list class="afd-list"></app-afdeling-list>
        </as-split-area>
        <as-split-area size="500">
            <klassiek-props></klassiek-props>
        </as-split-area>
    </as-split>
</div>
}